if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.realButton =
          document.getElementById('ProductSubmitButton-' + this.sectionId) ||
          document.querySelector('.product-form__submit');
        if (!this.realButton) return;

        this.priceEl = this.querySelector('[data-sticky-price]');
        this.submitEl = this.querySelector('[data-sticky-submit]');
        this.labelEl = this.querySelector('[data-sticky-label]');

        this.submitEl.addEventListener('click', () => {
          this.realButton.click();
        });

        var target = this.realButton.closest('.product-form__buttons') || this.realButton;
        this.observer = new IntersectionObserver(
          (entries) => {
            var entry = entries[0];
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.hidden = !passed;
            this.classList.toggle('sticky-atc--visible', passed);
          },
          { threshold: 0 }
        );
        this.observer.observe(target);

        // Keep price + availability in sync with variant changes.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event.data || event.data.sectionId !== this.sectionId) return;
            var html = event.data.html;
            if (html && this.priceEl) {
              var newPrice = html.getElementById('price-' + this.sectionId);
              if (newPrice) this.priceEl.innerHTML = newPrice.innerHTML;
            }
            this.mirrorButton();
          });
        }

        // Unavailable option combinations don't publish variantChange — mirror
        // the real button's disabled state directly.
        this.buttonObserver = new MutationObserver(() => this.mirrorButton());
        this.buttonObserver.observe(this.realButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      }

      mirrorButton() {
        if (!this.submitEl) return;
        this.submitEl.disabled = this.realButton.disabled;
        var realLabel = this.realButton.querySelector('span');
        if (realLabel && this.labelEl) this.labelEl.textContent = realLabel.textContent.trim();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
